import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useShowProductsSection = () => {
  const { data: user } = useUser();
  const {
    isStudent,
    activeSSLicense,
    activeELALicense,
    activeScienceLicense,
    activeEssentialsLicense,
  } = getUserProperties(user);
  const [showLockIconsExperiment] =
    useGetUserExperimentSegment("show_lock_icons");
  const showLicenseItemWithLock = showLockIconsExperiment === "on";

  return (
    activeELALicense ||
    activeSSLicense ||
    activeScienceLicense ||
    activeEssentialsLicense ||
    (!isStudent && showLicenseItemWithLock)
  );
};

export default useShowProductsSection;
